// extracted by mini-css-extract-plugin
export default {"root":"patient__ui__shared__examination-link__root"};